/**
 * Helper functions for form builder operations
 */

export const getQuestion = (schema, pageIndex, sectionIndex, questionIndex) => {
  return schema?.pages?.[pageIndex]?.sections?.[sectionIndex]?.questions?.[questionIndex];
};

export const getSection = (schema, pageIndex, sectionIndex) => {
  return schema?.pages?.[pageIndex]?.sections?.[sectionIndex];
};

export const getPage = (schema, pageIndex) => {
  return schema?.pages?.[pageIndex];
};

export const getAnswer = (schema, pageIndex, sectionIndex, questionIndex, answerIndex) => {
  return schema?.pages?.[pageIndex]?.sections?.[sectionIndex]?.questions?.[questionIndex]?.questionOptions?.answers?.[answerIndex];
};

export const getAnswers = (schema, pageIndex, sectionIndex, questionIndex) => {
  return schema?.pages?.[pageIndex]?.sections?.[sectionIndex]?.questions?.[questionIndex]?.questionOptions?.answers;
};

export const getSections = (schema, pageIndex) => {
  return schema?.pages?.[pageIndex]?.sections;
};

export const getQuestions = (schema, pageIndex, sectionIndex) => {
  return schema?.pages?.[pageIndex]?.sections?.[sectionIndex]?.questions;
};

/**
 * Deep clone an object
 */
export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

/**
 * Create a safe updater function for schema updates
 */
export const createSchemaUpdater = (schema, onSchemaChange) => {
  return (updater) => {
    if (!schema) return;
    const newSchema = { ...schema };
    updater(newSchema);
    onSchemaChange(newSchema);
  };
};
